module.exports = __webpack_public_path__ + "static/media/15.415852a0.mp3";